// import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";
(() => {
  const swiper = new Swiper(".best-sellers__swiper", {
    slidePerView: "auto",
    spaceBetween: 116,
    grabCursor: true,
    navigation: {
      nextEl: ".best-sellers__swiper-button-next",
      prevEl: ".best-sellers__swiper-button-prev",
    },
    pagination: {
      el: ".best-sellers__pagination",
      clickable: true,
      type: "bullets",
      renderBullet: function (index, className) {
        return '<span class="' + className + ' best-sellers-bullet">‎</span>';
      },
    },
    breakpoints: {
      360: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      450: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      650: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 116,
      },
    },
  });
})();
